import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import LinkStyled from "shared/ui/LinkStyled";
import AuthCardLayout from "../components/AuthCardLayout";
import LoginForm from "../components/LoginForm";

const LoginTeachersPage = () => {

    return (
        <Grid container spacing={4} justifyContent="center">
            <AuthCardLayout image="/images/account-type-2.svg" title="Brio în clasă" size="large" showBackButton={true}>
                <LoginForm type='teachers' />
                <LinkStyled to="/resetare-parola/profesori">Am uitat parola</LinkStyled>
                <Box mb={1.5} />
                <LinkStyled to="/inregistrare/profesori">Creează cont de profesor</LinkStyled>
            </AuthCardLayout>
        </Grid>
    )
};

export default LoginTeachersPage;
